/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCaseAlertReason } from './InternalApiCaseAlertReason';
import {
    InternalApiCaseAlertReasonFromJSON,
    InternalApiCaseAlertReasonFromJSONTyped,
    InternalApiCaseAlertReasonToJSON,
    InternalApiCaseAlertReasonToJSONTyped,
} from './InternalApiCaseAlertReason';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiCaseAlertData
 */
export interface InternalApiCaseAlertData {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseAlertData
     */
    id: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiCaseAlertData
     */
    type: InternalApiAlertType;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseAlertData
     */
    statusId: number;
    /**
     * 
     * @type {Array<InternalApiCaseAlertReason>}
     * @memberof InternalApiCaseAlertData
     */
    reasons: Array<InternalApiCaseAlertReason>;
}



/**
 * Check if a given object implements the InternalApiCaseAlertData interface.
 */
export function instanceOfInternalApiCaseAlertData(value: object): value is InternalApiCaseAlertData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function InternalApiCaseAlertDataFromJSON(json: any): InternalApiCaseAlertData {
    return InternalApiCaseAlertDataFromJSONTyped(json, false);
}

export function InternalApiCaseAlertDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAlertData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': InternalApiAlertTypeFromJSON(json['type']),
        'statusId': json['statusId'],
        'reasons': ((json['reasons'] as Array<any>).map(InternalApiCaseAlertReasonFromJSON)),
    };
}

export function InternalApiCaseAlertDataToJSON(json: any): InternalApiCaseAlertData {
    return InternalApiCaseAlertDataToJSONTyped(json, false);
}

export function InternalApiCaseAlertDataToJSONTyped(value?: InternalApiCaseAlertData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': InternalApiAlertTypeToJSON(value['type']),
        'statusId': value['statusId'],
        'reasons': ((value['reasons'] as Array<any>).map(InternalApiCaseAlertReasonToJSON)),
    };
}

